<template>
  <section class="legacy-page-placeholder">
    <h2>管理员工作台</h2>
    <p>该历史页面暂未配置内容，请从左侧进入 DeRAS 管理模块。</p>
  </section>
</template>

<style scoped>
.legacy-page-placeholder {
  padding: 32px;
  color: #1f2937;
}
</style>
